import React, { useState, Fragment, useCallback, useEffect } from "react";
import { Popover } from "react-tiny-popover";
import { Link } from "react-router-dom";
import { Buffer } from "buffer";
import IconButton from "../iconButton";
import ChevronDownIcon from "../../icons/chevronDownIcon";
import LogoutIcon from "../../icons/logoutIcon";
// import RightArrow from "../../icons/rightArrow";
import { MENU_SLUG } from "../../constants/constants";
import useMediaQuery from "../../hooks/useMediaQuery";
import UserImage from "../../assets/images/user.png";
import useLogout from "../../hooks/useLogout";
import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
import styles from "./style.module.css";

const ProfileDropdown = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const axiosPrivate = useAxiosPrivate();
  const [isOpen, setIsOpen] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [profileData, setProfileData] = useState({});
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const logout = useLogout();

  const signOut = async () => {
    await logout();
  };

  const fetchProfileInfo = useCallback(async () => {
    try {
      let url = `user/profile`;
      let options = {
        method: "GET",
        url,
      };
      await axiosPrivate(options)
        .then((response) => {
          if (response.data.status === 1) {
            let profilePictureBuffer =
              response.data?.profilePictureBuffer?.data;
            let tempData = {
              name: response.data.user.name,
            };
            if (profilePictureBuffer && profilePictureBuffer.length > 0) {
              const base64String =
                Buffer.from(profilePictureBuffer).toString("base64");
              let image = `data:image/jpeg;base64,${base64String}`;
              tempData.img = image;
            }
            setProfileData(tempData);
          }
        })
        .catch((err) => {
          if (err.response) {
            // console.error('err.res', err.response.data);
          }
        });
    } catch (error) {
      // console.error('error', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchProfileInfo();
  }, [fetchProfileInfo, isMobile, isOpen]);

  return (
    <Fragment>
      {isMobile ? (
        <div className={styles.profile_dropdown}>
          <button
            className={`${styles.user_btn} ${isOpen ? styles.open : ""}`}
            onClick={toggleDropdown}
          >
            <img className="profile-img" src={profileData.img || UserImage} alt={profileData.name} />
            <ChevronDownIcon />
          </button>
          {isOpen && (
            <div className={styles.profile_info}>
              <div className={styles.profile_info_img}>
                <div className={styles.profile_info_img_inner}>
                  <img className="profile-img" src={profileData.img || UserImage} alt={profileData.name} />
                </div>
              </div>
              <div className={styles.profile_info_name}>{profileData.name}</div>
              <div className={styles.profile_info_link}>
                <Link to={`/${MENU_SLUG.profile}`}>View Profile</Link>
              </div>
              <div className={styles.profile_info_logout}>
                <button type="button" onClick={signOut}>
                  <LogoutIcon />
                  <span>Logout</span>
                  {/* <RightArrow /> */}
                </button>
              </div>
            </div>
          )}
        </div>
      ) : (
        <Popover
          isOpen={isPopoverOpen}
          positions={['bottom']}
          align="end"
          padding={5}
          onClickOutside={() => setIsPopoverOpen(false)}
          reposition={true}
          boundaryInset={20}
          content={() => (
            <div className={styles.profile_options}>
              <Link to={`/${MENU_SLUG.profile}`}>View Profile</Link>
              <button type="button" onClick={signOut}>
                <LogoutIcon />
                <span>Logout</span>
                {/* <RightArrow /> */}
              </button>
            </div>
          )}
        >
          <div className={styles.profile_dropdown}>
            <IconButton
              icon={<img className="profile-img" src={profileData.img || UserImage} alt={profileData.name} />}
              customClass={styles.user_icon_btn}
              onClick={() => setIsPopoverOpen(!isPopoverOpen)}
            />
          </div>
        </Popover>
      )}
    </Fragment>
  );
};

export default ProfileDropdown;
